import { RootState } from "redux/rootReducer";

export const selectIsDownloadingPDF = (state: RootState) =>
  state.pdfDownloadTypeInfo.loading;
export const pdfDownloadErrorMessage = (state: RootState) =>
  state.pdfDownloadTypeInfo.error;
export const pdfDownloadSuccessResponse = (state: RootState) =>
  state.pdfDownloadTypeInfo.pdfDownloadTypeInfoResponse;
